/**
 * Generates a consistent color for an avatar based on a string (usually name)
 * @param {string} str - The string to generate color from (typically user name)
 * @returns {string} - A hex color code
 */
export const getAvatarColor = (str) => {
  if (!str) return "#1976d2"; // Default blue if no string provided

  // Simple hash function
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash; // Convert to 32-bit integer
  }

  // Generate HSL color with good saturation and lightness for readability
  const hue = Math.abs(hash % 360); // 0-360 degrees
  const saturation = 65; // 65% - vibrant but not overwhelming
  const lightness = 50; // 50% - balanced brightness

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

/**
 * Derives avatar initials from a name (max 2 characters).
 * - 1 token  → first character (e.g. "Madonna" → "M")
 * - 2+ tokens → first char of FIRST token + first char of LAST token
 *   (covers 3-4 part names: first name + last name, e.g. "Amine Ben Salah" → "AS")
 * @param {string} name - The name to derive initials from
 * @returns {string} - Uppercase initials, or "" when no name is provided
 */
export const getAvatarInitials = (name) => {
  if (!name || typeof name !== "string") return "";
  const tokens = name.trim().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return "";
  if (tokens.length === 1) {
    return tokens[0].charAt(0).toUpperCase();
  }
  return (
    tokens[0].charAt(0) + tokens[tokens.length - 1].charAt(0)
  ).toUpperCase();
};
